import { Link } from "react-router-dom";
import { MapPin, Ruler, Star, Waves } from "lucide-react";
import { availableDurations, formatPrice } from "@/lib/durations";
import { resolveImageUrl } from "@/components/ImageUploader";

export default function ListingCard({ dock }) {
  const img = resolveImageUrl(dock.images?.[0]) || "https://images.unsplash.com/photo-1603473036383-df544a1dcada?w=1200&q=80";
  const durs = availableDurations(dock);
  const primary = durs[0];
  const showPwcBadge = dock.accommodates_pwc === true;
  return (
    <Link
      to={`/docks/${dock.dock_id}`}
      data-testid={`listing-card-${dock.dock_id}`}
      className="group block"
    >
      <div className="relative aspect-[4/5] overflow-hidden rounded-xl border border-border bg-secondary">
        <img
          src={img}
          alt={dock.title}
          className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-105"
          loading="lazy"
        />
        {showPwcBadge && (
          <div data-testid="pwc-badge" className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-accent/95 backdrop-blur-md px-2.5 py-1 text-[10px] uppercase tracking-widest text-accent-foreground font-medium">
            <Waves className="h-3 w-3" strokeWidth={2}/> Jet Ski OK
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute left-3 bottom-3 right-3 flex items-end justify-between text-white">
          <div>
            <div className="text-[11px] uppercase tracking-widest opacity-90">{dock.lake}</div>
            <div className="font-display text-lg leading-tight line-clamp-1">{dock.title}</div>
          </div>
          <div className="flex items-center gap-1 rounded-full bg-white/15 backdrop-blur-md px-2.5 py-1 text-xs">
            <Star className="h-3 w-3 fill-white" strokeWidth={1.5}/>
            <span>4.9</span>
          </div>
        </div>
      </div>
      <div className="mt-3 flex items-center justify-between">
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" strokeWidth={1.5}/>{dock.city}</span>
          <span className="inline-flex items-center gap-1"><Ruler className="h-3.5 w-3.5" strokeWidth={1.5}/>up to {dock.max_boat_length_ft}ft</span>
        </div>
        <div className="text-right">
          {primary ? (
            <>
              {durs.length > 1 && <span className="text-xs text-muted-foreground mr-1">from</span>}
              <span className="font-medium">{formatPrice(primary.price)}</span>
              <span className="text-muted-foreground text-sm">{primary.shortSuffix}</span>
            </>
          ) : (
            <span className="text-sm text-muted-foreground">Price on request</span>
          )}
        </div>
      </div>
    </Link>
  );
}
